import React, { useEffect, useRef } from "react";
import clock from '../assets/images/clock.svg'
import darkGreenArrowOutline from '../assets/images/dark-outline-arrow.svg'



const Agenda = () => {
const timelineRef = useRef(null);

    const createTimelineConnections = () => {
        if (!timelineRef.current) return;
        
        const timeline = timelineRef.current;
        const items = timeline.querySelectorAll('.timeline-item');
        
        // Remove existing connecting lines
        timeline.querySelectorAll('.connecting-line').forEach(line => line.remove());
        
        // Create connecting lines between items (excluding last item)
        for (let i = 0; i < items.length - 1; i++) {
            const currentItem = items[i];
            const nextItem = items[i + 1];
            
            const currentMarker = currentItem.querySelector('.timeline-marker');
            const nextMarker = nextItem.querySelector('.timeline-marker');
            
            if (currentMarker && nextMarker) {
                // Calculate positions relative to timeline container
                const currentRect = currentMarker.getBoundingClientRect();
                const nextRect = nextMarker.getBoundingClientRect();
                const timelineRect = timeline.getBoundingClientRect();
                
                // Create connecting line element
                const line = document.createElement('div');
                line.className = 'connecting-line';
                line.style.position = 'absolute';
                line.style.left = '7px'; // Same as marker center
                line.style.width = '2px';
                line.style.background = '#82BB03';
                line.style.zIndex = '0';
                
                // Calculate top position and height
                const startY = currentRect.top - timelineRect.top + currentRect.height / 2;
                const endY = nextRect.top - timelineRect.top + nextRect.height / 2;
                
                line.style.top = startY + 'px';
                line.style.height = (endY - startY) + 'px';
                
                timeline.appendChild(line);
            }
        }
    };

    useEffect(() => {
        // Create connections after component mounts
        createTimelineConnections();
        
        // Recreate connections on window resize
        const handleResize = () => {
            createTimelineConnections();
        };
        
        window.addEventListener('resize', handleResize);
        
        // Cleanup event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return(
        <div className="timeline" ref={timelineRef}>
                    <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">Registration & Welcome Coffee</span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 08:00 AM - 08:45 AM
                            </span>
                        </div>
                    </div>

                    
                    <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">Opening Remarks by SNB Capital</span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 08:45 AM - 08:55 AM
                            </span>
                        </div>
                    </div>
               
                    <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">Meetings</span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 09:00 AM - 12:00 PM
                            </span>
                        </div>
                    </div>
               
                    <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">Prayer Break & Networking Lunch</span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 12:00 PM - 01:00 PM
                            </span>
                        </div>
                    </div>

                    <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">Meetings</span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 01:00 PM - 06:00 PM
                            </span>
                        </div>
                    </div>
               
                </div>
    )
}


export default Agenda;


{/* <div className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="custom-card">
                            <span className="main-text">
                                Roundtable:
                                <span className="roundtable-agenda">
                                    <img src={darkGreenArrowOutline} alt="" /> Welcome by SNB Capital
                                </span>
                                <span className="roundtable-agenda">
                                    <img src={darkGreenArrowOutline} alt="" /> CMA, Saudi Exchange Update
                                </span>
                                <span className="roundtable-agenda">
                                    <img src={darkGreenArrowOutline} alt="" /> SNB Capital Update
                                </span>
                                <span className="roundtable-agenda">
                                    <img src={darkGreenArrowOutline} alt="" /> Closing Remarks
                                </span>
                            </span>
                            <span className="highlight">
                                <img src={clock} alt="" /> 09:00 AM - 10:00 AM
                            </span>
                        </div>
                    </div> */}
